import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiServices } from '../../services/Api';

const LoginForm = () => {
    const [mobileNumber, setMobileNumber] = useState('');
    const navigate = useNavigate();
    const [error, setError] = useState('');

    const handleUsernameChange = (event) => {
        setMobileNumber(event.target.value);
        if (event.target.value.match(/^[0-9]{10}$/)) setError('');
    };

    // const handlePasswordChange = (event) => {
    //     setPassword(event.target.value);
    // };

    const handleSubmit = async (event) => {
        
        if (!mobileNumber.match(/^[0-9]{10}$/)) {
            setError('Please enter a valid 10-digit mobile number');
            return;
        }
        else {
            setError('');
           

            let sessionId = '';

            try {
                const response = await apiServices.post('auth/otp/send', { phoneNumber: mobileNumber });
                sessionId = response;
                sessionId = sessionId.replace(/-/g, '');
                navigate('/otpverify', { state: { sessionId, mobileNumber } });

            } catch (error) {
                console.log('Error:', error);
            }

        }

    };

    return (
        <div className="flex flex-col font-['Roboto',sans-serif] w-[32.6875rem] mx-auto bg-white p-6 rounded-lg gap-8 shadow-[0_0_10px_rgba(0,0,0,0.1)] max-md:w-full max-md:rounded-none">
            <div>
                <h2 className="text-[#454545] font-['Roboto'] text-2xl font-bold leading-normal mb-2 max-md:text-xl">Login</h2>
                <p className="mb-5 text-[#9D9D9D] font-['Roboto'] text-base font-normal leading-normal max-md:text-xs">Please enter details to login</p>
                <hr className="border-[0.6px] border-[#EBEBEB]" />
            </div>
            <div>
                <span>Mobile</span>
                <input required type="text" value={mobileNumber} pattern="[0-9]*" maxLength="10" onChange={handleUsernameChange} placeholder="Enter your mobile number" className="flex h-11 items-center flex-1 w-full py-2.5 px-3 mb-2 rounded-lg border border-brand-border bg-white text-[#9D9D9D] font-['Roboto'] text-base font-normal leading-normal max-md:text-base" />
                <div style={{ marginBottom: '4px' }}>
                    {error && <span className="error-message">{error}</span>}
                </div>
                {/* <span>Password</span>
                <input required type="password" value={password} onChange={handlePasswordChange} placeholder="Password" className="input-field" /> */}
            </div>
            <div>
                <button className="text-white h-11 py-2.5 px-7 border-none rounded-lg bg-primary cursor-pointer text-base w-full mb-5" onClick={handleSubmit} >Submit</button>
                <p className="text-[#454545] text-center font-['Roboto'] text-base font-bold leading-normal mb-5">OR</p>
                <p className="text-[#454545] text-center font-['Roboto'] text-base font-normal leading-normal">
                    Don't have an account yet? <button onClick={() => { navigate('/sign-up') }} className="text-[#1567A7] font-['Roboto'] text-base font-normal leading-normal no-underline cursor-pointer hover:no-underline bg-transparent border-none p-0 inline">Register</button>
                </p>
            </div>
        </div>
    );
};

export default LoginForm;

